module.exports = __webpack_public_path__ + "img/ktb-2.3b4f30cb.png";